import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Select from "../../ui/PortalSelect";
import axios from "axios";
import { DatePicker } from "antd";
import moment from "moment";
import Swal from "sweetalert2";
import { baseURL } from "../backend_url";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {Pagination } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
import { DataRegion, FormSection, PageHeader } from '../../ui';
import {
  buildReviewScope,
  buildSelectedReviewPayload,
  canOfferAllLocations,
  isSelectedReviewSaveSuccess,
  readSelectedReviewResponse,
  reviewApiErrorMessage,
} from './reviewSelectionContract';
import './ReviewScreen.css';
const ReviewScreen = () => {
  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [accountNames, setAccountNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [LocationData, setLocationData] = useState([]);
  const [selectedLocationId, setselectedLocationId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectReview, setSelectReview] = useState([false, false, false, false, false])
  const [selectAllReview, setSelectAllReview] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [selectedReviews, setSelectedReviews] = useState([]);
  const [reviewConfigAccountId, setReviewConfigAccountId] = useState("");
  const [reviewConfigAccountName, setReviewConfigAccountName] = useState("");
  const [reviewSelectionLoading, setReviewSelectionLoading] = useState(false);
  const [reviewSelectionReady, setReviewSelectionReady] = useState(false);
  const [savingSelectedReviews, setSavingSelectedReviews] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [accessType, setAccessType] = useState("Edit");
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 100;
  // Calculate the total number of pages
  const totalPages = Math.ceil(allReviews.length / reviewsPerPage);
  // Get the reviews for the current page
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = allReviews.slice(indexOfFirstReview, indexOfLastReview);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleInputChangeAccountName = (characterEntered) => {
    setSelectedAccountName(characterEntered?.accountName || "");
    setSelectedAccountId(characterEntered?.value || "");
    setselectedLocationId("");
    setLocationData([]);
  };
  const handleInputChangeLocationName = (selectedoption) => {
    setselectedLocationId(selectedoption?.value || "");
  };
  // dropdown for Company Names as options
  const companyNameOptions = accountNames.map((value) => ({
    value: String(value._id),
    label: `${value.company_name} (${value._id})`,
    accountName: value.company_name,
  }));
  const locationNameOptions = LocationData.map((value) => ({
    value: value.location_id,
    label: `${value.location_name} (${value.location_id})`,
    locationName: value.location_name,
  }));
  const selectedAccountOption = companyNameOptions.find(
    (option) => option.value === String(selectedAccountId)
  ) || null;
  const selectedLocationOption = locationNameOptions.find(
    (option) => option.value === selectedLocationId
  ) || null;
  useEffect(() => {
    const fetchCompanyNames = async () => {
      const { user: foundUser } = readSessionUser();
      if (!foundUser) {
        setAccountNames([]);
        return;
      }

      try {
        setLoggedInUserDetail(foundUser);
        const accounts = await loadAccessibleCompanies(
          baseURL,
          foundUser,
          "ReviewScreen_Account Access"
        );
        const routesAccounts = accounts.filter(
          (account) => account['company_name'] === 'Routes Car Rental'
        );
        setAccountNames(routesAccounts);
        setAccessType(
          foundUser.role_capabilities?.all_modules_access === true
            ? 'Edit'
            : foundUser.access['ReviewScreen_Access Specifier']
        );
      } catch (error) {
        setAccountNames([]);
      }
    };
    fetchCompanyNames();
  }, []);
  useEffect(() => {
    if (!selectedAccountId || !loggedInUserDetail?.userEmail) return undefined;

    const controller = new AbortController();
    const loadLocations = async () => {
      try {
        setLocationData([]);
        setselectedLocationId("");
        const locationResponse = await fetch(
          `${baseURL}/get_company_location/${encodeURIComponent(selectedAccountId)}`
            + `?companyNumber=${encodeURIComponent(selectedAccountId)}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            signal: controller.signal,
          }
        );
        const locationPayload = await locationResponse.json();
        if (!locationResponse.ok) {
          throw new Error(locationPayload?.error || 'Unable to load account locations');
        }
        if (!Array.isArray(locationPayload?.res)) {
          throw new Error('The server returned an invalid location list');
        }

        let accessibleLocations = [...locationPayload.res];
        const accountLocationCount = accessibleLocations.length;
        const hasAllModulesAccess = (
          loggedInUserDetail.role_capabilities?.all_modules_access === true
        );
        if (!hasAllModulesAccess) {
          const userResponse = await axios.post(
            baseURL + "/get_individual_user_details",
            {
              user_email: loggedInUserDetail.userEmail,
              companyNumber: selectedAccountId,
              account_id: selectedAccountId,
            },
            { signal: controller.signal }
          );
          if (!Array.isArray(userResponse.data) || userResponse.data.length !== 1) {
            throw new Error('Your location allocation could not be verified');
          }
          const scopedUser = userResponse.data[0];
          if (String(scopedUser.company_id) !== String(selectedAccountId)) {
            throw new Error('The user allocation did not match the selected account');
          }
          const allocatedLocations = scopedUser.location_allocated || {};
          accessibleLocations = accessibleLocations.filter(
            (location) => location && allocatedLocations[location.location_id]
          );
        }

        if (canOfferAllLocations(
          accountLocationCount,
          accessibleLocations.length,
          hasAllModulesAccess,
        )) {
          accessibleLocations.push({
            location_id: "all_locations",
            location_name: "All Locations",
          });
        }
        if (!controller.signal.aborted) {
          setLocationData(accessibleLocations);
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        setLocationData([]);
        setselectedLocationId("");
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Locations unavailable',
          text: reviewApiErrorMessage(
            error,
            'Unable to load locations for this account.',
          ),
        });
      }
    };

    loadLocations();
    return () => controller.abort();
  }, [selectedAccountId, loggedInUserDetail]);
  const handleFetch = () => {
    if (selectedAccountId === "") {
      Swal.fire("Please select an account to proceed ahead");
      return;
    }
    if (selectedLocationId === "" && selectedAccountId !== "all_affiliate") {
      Swal.fire("Please select location to proceed ahead");
      return;
    }
    let rating_flag = false;
    for(let i=0; i<selectReview.length; i++){
      if(selectReview[i]){
        rating_flag = true;
        break;
      }
    }
    if(!rating_flag){
      Swal.fire("Please select rating to proceed ahead");
      return;
    }
    if (fromDate === "") {
      Swal.fire("Please select From Date to proceed ahead");
      return;
    }
    if (toDate === "") {
      Swal.fire("Please select To Date to proceed ahead");
      return;
    }
    const obj = {
      ...buildReviewScope(selectedAccountId),
      Pickup_Location: selectedLocationId,
      from_date: fromDate?.format("YYYY-MM-DD"),
      to_date: toDate?.format("YYYY-MM-DD"),
      rating: selectReview,
    };
    setLoading(true);
    axios.post(baseURL + "/get_all_review", obj)
      .then((res) => {
        if (!Array.isArray(res.data)) {
          throw new Error('The server returned an invalid review list');
        }
        setCurrentPage(1);
        setAllReviews(res.data);
      })
      .catch((error) => {
        console.error('Unable to load reviews:', error)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Request failed',
          text: reviewApiErrorMessage(
            error,
            'Unable to load reviews. Please try again.',
          ),
        })
      })
      .finally(() => setLoading(false));
  }
  const handleCheckbox = (val, indx) => {
    const select_review = [...selectReview]
    select_review[indx] = !val
    let flag = true
    for (let i = 0; i < select_review.length; i++) {
      if (!select_review[i]) {
        flag = false
      }
    }
    setSelectAllReview(flag)
    setSelectReview(select_review);
  }
  const handleAllReviewCheckbox = () => {
    const select_review = [...selectReview]
    for (let i = 0; i < selectReview.length; i++) {
      select_review[i] = !selectAllReview ? true : false;
    }
    setSelectAllReview(!selectAllReview)
    setSelectReview(select_review);
  }
  const handleSubmitReviews = async () => {
    if (!reviewConfigAccountId) {
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Account required',
        text: 'Select an account before saving website reviews.',
      });
      return;
    }

    setSavingSelectedReviews(true);
    try {
      const payload = buildSelectedReviewPayload(
        reviewConfigAccountId,
        selectedReviews,
      );
      const response = await axios.post(
        baseURL + "/save_selected_review",
        payload,
      );
      if (!isSelectedReviewSaveSuccess(
        response.data,
        reviewConfigAccountId,
        selectedReviews,
      )) {
        throw new Error('The server did not confirm the saved review selection');
      }
      await Swal.fire({
        position: 'center',
        icon: "success",
        title: "Saved Successfully",
        text: `Website reviews were saved for ${reviewConfigAccountName} (${reviewConfigAccountId}).`,
      });
      setShowModal(false);
    } catch (error) {
      console.error('Unable to save selected reviews:', error)
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Save failed',
        text: reviewApiErrorMessage(
          error,
          'Unable to save the selected reviews. Please try again.',
        ),
      });
    } finally {
      setSavingSelectedReviews(false);
    }
  };
  const handleDeselectAll = () => {
    setSelectedReviews([]);
  };
  const handleReviewSelection = (reviewId) => {
    if (selectedReviews.includes(reviewId)) {
      setSelectedReviews(selectedReviews.filter((_id) => _id !== reviewId));
    } else {
      if (selectedReviews.length < 15) {
        setSelectedReviews([...selectedReviews, reviewId]);
      } else {
        Swal.fire({
          position: 'center',
          icon: "warning",
          title: "Limit Reached",
          text: "You can only select up to 15 reviews.",
        });
      }
    }
  };
  const handleSelectReviews = async () => {
    if (!selectedAccountId) {
      await Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Account required',
        text: 'Select an account before choosing website reviews.',
      });
      return;
    }

    const accountId = String(selectedAccountId);
    const accountName = selectedAccountName;
    if (reviewConfigAccountId && reviewConfigAccountId !== accountId) {
      setReviews([]);
      setSelectedReviews([]);
    }
    setReviewConfigAccountId(accountId);
    setReviewConfigAccountName(accountName);
    setReviewSelectionReady(false);
    setShowModal(true);
    setReviewSelectionLoading(true);

    try {
      const params = buildReviewScope(accountId);
      const [recentResponse, selectedResponse] = await Promise.all([
        axios.get(baseURL + "/get_recent_reviews", {
          params: { ...params, limit: 500 },
        }),
        axios.get(baseURL + "/get_selected_review", { params }),
      ]);
      if (!Array.isArray(recentResponse.data)) {
        throw new Error('The server returned an invalid recent-review list');
      }
      const accountSelectedReviews = readSelectedReviewResponse(
        selectedResponse.data,
        accountId,
      );
      setReviews(recentResponse.data);
      setSelectedReviews(accountSelectedReviews);
      setReviewSelectionReady(true);
    } catch (error) {
      setReviewSelectionReady(false);
      console.error('Unable to load review selection:', error);
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Unable to load reviews',
        text: reviewApiErrorMessage(
          error,
          'Unable to load the website review selection. Please try again.',
        ),
      });
    } finally {
      setReviewSelectionLoading(false);
    }
  };
  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Convert reviews to a worksheet
    const worksheetData = allReviews.map(review => ({
      Rating: review.rating,
      Review: review.text,
      Author: review.author_name,
      Location: review.place_name,
      Date: (review.time).slice(0, -3)
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reviews");
    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "reviews.xlsx");
  };
  return (
    <>
      <main className="container-fluid review-screen-page">
        <PageHeader
          className="review-screen-page-header"
          eyebrow="Customer feedback"
          title="Review Screen"
          subtitle="Filter customer feedback, export review data, and curate the reviews displayed on the website."
          actions={(
            <Button variant="primary" onClick={handleSelectReviews}>
              Select Reviews for Website
            </Button>
          )}
        />

        <FormSection
          className="review-screen-filter-panel"
          title="Review filters"
          description="Choose an account, location, rating, and date range to find relevant reviews."
          footer={(
            <div className="review-screen-fetch-action">
              {loading ? (
                <button className="btn btn-success" type="button" disabled>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  Fetching Review
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={handleFetch}
                >
                  Fetch Review
                </button>
              )}
            </div>
          )}
        >
          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <label
                htmlFor="review-account"
                className="form-label"
              >
                Select Account Name
              </label>
              <Select
                inputId="review-account"
                className="review-screen-select"
                classNamePrefix="review-select"
                name="form-field-name"
                value={selectedAccountOption}
                options={companyNameOptions}
                onChange={handleInputChangeAccountName}
                placeholder="Select Account..."
              />
            </div>
            <div className="col-12 col-lg-6">
              <label
                htmlFor="review-location"
                className="form-label"
              >
                Select Location Name
              </label>
              <Select
                className="review-screen-select"
                classNamePrefix="review-select"
                value={selectedLocationOption}
                inputId="review-location"
                name="Select Location"
                options={locationNameOptions}
                onChange={handleInputChangeLocationName}
                placeholder="Select Location"
                isDisabled={selectedAccountId === "all_affiliate"}
              />
            </div>
            <div className="col-12">
              <label className="form-label">
                Select Rating
              </label>
              <div className="review-rating-options">
                <label className="review-rating-option">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectAllReview}
                    onChange={handleAllReviewCheckbox}
                  />
                  <span>Select All</span>
                </label>
                {selectReview.map((val, indx) => (
                  <label
                    className="review-rating-option"
                    key={indx}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={val}
                      onChange={() => handleCheckbox(val, indx)}
                    />
                    <span>{`${indx + 1} Star`}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <label className="form-label">
                From Date*
              </label>
              <DatePicker
                size="large"
                format="MM-DD-YYYY"
                placeholder="mm-dd-yyyy"
                onChange={(date, dateString) => {
                  setFromDate(date);
                }}
                style={{ width: "100%", position: "relative" }}
                value={fromDate ? moment(new Date(fromDate)) : fromDate}
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
              />
            </div>
            <div className="col-12 col-lg-6">
              <label className="form-label">
                To Date*
              </label>
              <DatePicker
                size="large"
                format="MM-DD-YYYY"
                placeholder="mm-dd-yyyy"
                onChange={(date, dateString) => setToDate(date)}
                style={{ width: "100%" }}
                value={toDate ? moment(new Date(toDate)) : toDate}
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
              />
            </div>
          </div>
        </FormSection>

        {allReviews.length > 0 && (
          <DataRegion
            className="review-screen-results"
            title="Existing Reviews"
            count={allReviews.length}
            countLabel="reviews"
            actions={(
              <Button variant="secondary" onClick={downloadExcel}>
                Download Excel
              </Button>
            )}
            footer={(
              <div className="review-screen-pagination">
                <span>100 reviews per page</span>
                <Pagination className="flex-wrap gap-1 mb-0">
                  {[...Array(totalPages).keys()].map(number => (
                    <Pagination.Item
                      key={number + 1}
                      active={number + 1 === currentPage}
                      onClick={() => handlePageChange(number + 1)}
                    >
                      {number + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            )}
          >
            <Table striped bordered hover className="mb-0 review-screen-table">
              <thead>
                <tr>
                  <th>Rating</th>
                  <th>Review</th>
                  <th>Author</th>
                  <th>Location</th>
                  <th>Date of Review</th>
                </tr>
              </thead>
              <tbody>
                {currentReviews.map((review) => (
                  <tr key={review._id}>
                    <td className="text-center align-middle" style={{ backgroundColor: review.rating <= 2 ? '#EF5350' : review.rating === 3 ? '#FFE599' : '#4CAF50', color: review.rating === 3 ? '#5f4700' : 'white' }}>
                      <strong>{review.rating}</strong>
                    </td>
                    <td>{review.text}</td>
                    <td>{review.author_name}</td>
                    <td>{review.place_name}</td>
                    <td>{(review.time).slice(0, -3)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </DataRegion>
        )}
      </main>
      {/* Modal for Review Selection */}
      <Modal
        show={showModal}
        onHide={() => {
          if (!savingSelectedReviews) {
            setShowModal(false);
          }
        }}
        size="xl"
        scrollable
        dialogClassName="review-selection-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Select Reviews for Website
            {reviewConfigAccountId
              ? ` - ${reviewConfigAccountName} (${reviewConfigAccountId})`
              : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            { accessType === 'Edit' &&
          <Button
            variant="danger"
            onClick={handleDeselectAll}
            disabled={
              !reviewSelectionReady
              || reviewSelectionLoading
              || savingSelectedReviews
            }
          >
              Deselect All
            </Button>
}
            <span className="mx-auto">
              {reviewSelectionLoading
                ? 'Loading review selection...'
                : `Selected Review Count: ${selectedReviews.length}`}
            </span>
            {accessType === 'Edit' &&
            <Button
              variant="primary"
              onClick={handleSubmitReviews}
              disabled={
                !reviewSelectionReady
                || reviewSelectionLoading
                || savingSelectedReviews
              }
            >
              {savingSelectedReviews ? 'Saving...' : 'Submit'}
            </Button>
}
          
          </div>
          <div className="table-responsive">
          <Table striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th>Select</th>
                <th>Rating</th>
                <th>Review</th>
                <th>Author</th>
                <th>Location</th>
                <th>Date of Review</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map((review) => (
                <tr key={review._id}>
                  <td>
                    <input
                      type="checkbox"
                      aria-label={`Select review by ${review.author_name}`}
                      checked={selectedReviews.includes(review._id)}
                      onChange={() => handleReviewSelection(review._id)}
                      style={{
                        transform: 'scale(1.5)',
                        margin: '10px',
                      }}
                      disabled={
                        accessType !== 'Edit'
                        || !reviewSelectionReady
                        || reviewSelectionLoading
                        || savingSelectedReviews
                      }
                    />
                  </td>
                  <td className="text-center align-middle" style={{ backgroundColor: review.rating <= 2 ? '#EF5350' : review.rating === 3 ? '#FFE599' : '#4CAF50', color: review.rating === 3 ? '#5f4700' : 'white' }}><strong>{review.rating}</strong></td>
                  {/* <td><pre>{review.text}</pre></td> */}
                  <td>{review.text}</td>
                  <td>{review.author_name}</td>
                  <td>{review.place_name}</td>
                  <td>{(review.time).slice(0, -3)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          { accessType === 'Edit' &&
          <Button
            variant="primary"
            onClick={handleSubmitReviews}
            disabled={
              !reviewSelectionReady
              || reviewSelectionLoading
              || savingSelectedReviews
            }
          >
            {savingSelectedReviews ? 'Saving...' : 'Submit'}
          </Button>
}
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ReviewScreen;
